<template>
  <div class="match-stats">
    <div class="return-btn" @click="returnpage">
      <i
        :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
        class="el-icon-arrow-right"
      ></i>
    </div>
    <!-- team data -->
    <template>
      <el-table
        :empty-text="$t('home.nodata')"
        :class="headType === '1' ? 'is-el-table' : 'is-el-table-girl'"
        :data="matchData.team_data_total"
        border
      >
        <el-table-column fixed prop="team_name">
          <template slot="header">
            <span class="table-header">TEAM</span>
          </template></el-table-column
        >
        <el-table-column
          v-for="(item, index) in titleHeader"
          :key="index"
          :prop="item.value"
          width="62px"
        >
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.full_title"
              placement="top"
            >
              <span
                class="table-header"
                style="display:block;text-align:center;"
                >{{ item.label }}</span
              >
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- first team menbers data -->
    <template>
      <p
        :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
        class="title-team-name"
      >
        {{ matchData.first_team_name }}
      </p>
      <el-table
        max-height="400"
        stripe
        :empty-text="$t('home.nodata')"
        :class="headType === '1' ? 'is-el-table' : 'is-el-table-girl'"
        :data="matchData.first_team_members"
        border
      >
        <el-table-column fixed prop="team_member_name">
          <template slot="header">
            <span class="table-header">NAME</span>
          </template></el-table-column
        >
        <el-table-column
          v-for="(item, index) in titleHeader"
          :key="index"
          :prop="item.value"
          width="62px"
        >
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.full_title"
              placement="top"
            >
              <span
                class="table-header"
                style="display:block;text-align:center;"
                >{{ item.label }}</span
              >
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- second team menbers data -->
    <template>
      <p
        :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
        class="title-team-name"
      >
        {{ matchData.second_team_name }}
      </p>
      <el-table
        stripe
        max-height="400"
        :empty-text="$t('home.nodata')"
        :class="headType === '1' ? 'is-el-table' : 'is-el-table-girl'"
        :data="matchData.second_team_members"
        border
      >
        <el-table-column fixed prop="team_member_name">
          <template slot="header">
            <span class="table-header">NAME</span>
          </template></el-table-column
        >
        <el-table-column
          v-for="(item, index) in titleHeader"
          :key="index"
          :prop="item.value"
          width="62px"
        >
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.full_title"
              placement="top"
            >
              <span
                class="table-header"
                style="display:block;text-align:center;"
                >{{ item.label }}</span
              >
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import titleHeader from "../../../commen/commen_title";

export default {
  props: ["matchData"],
  mixins: [titleHeader],
  data() {
    return {
      schedule_list: 2
    };
  },
  computed: {
    ...mapState(["headType"])
  },
  methods: {
    returnpage() {
      this.$emit("returnpage");
    }
  },
  created() {
    console.log(this.matchData)
  }
};
</script>
<style lang="scss">
.match-stats {
  .is-el-table {
    margin-top: 30px;
    border-radius: 15px;
    box-shadow: 2px 2px 10px rgb(219, 217, 217);
    thead {
      tr {
        th {
          background: #318bc8;
        }
      }
    }
  }
  .is-el-table-girl {
    margin-top: 30px;
    border-radius: 15px;
    box-shadow: 2px 2px 10px rgb(219, 217, 217);
    thead {
      tr {
        th {
          background: #b9a2c9;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.match-stats {
  width: 90%;
  margin-left: 5%;
  height: 100%;
  padding-bottom: 80px;
  .return-btn {
    margin: 20px 0;
    height: 40px;
    i {
      float: right;
      color: #318bc8;
      border-radius: 20px;
      line-height: 40px;
      height: 40px;
      width: 60px;
      box-shadow: 2px 2px 10px rgb(219, 217, 217);
      cursor: pointer;
    }
    i:hover {
      background: rgba(243, 241, 241, 0.637);
    }
  }
  .title-team-name {
    color: #318bc8;
    font-weight: 600;
    font-size: 35px;
    margin: 20px 0;
  }
  .table {
    border-radius: 15px;
    box-shadow: 2px 2px 15px rgba(192, 191, 191, 0.781);
    overflow: hidden;
    margin-bottom: 40px;

    .head {
      color: #2d3b51;
      display: flex;
      padding: 20px 0;
      align-items: center;
      justify-content: space-around;
      border-bottom: 2px solid rgba(226, 226, 226, 0.568);
      span {
        // padding: 0px 5px;
        width: 7%;
      }
      :nth-child(1) {
        width: 10%;
      }
    }
    .head1 {
      background: #318bc8;
      color: #fff;
      font-size: 15px;
      font-weight: 600;
    }
    .members-header {
      line-height: 40px;
      background: #318bc8;
      color: #fff;
    }

    tbody tr {
      line-height: 40px;
      transition: all 0.6s;
    }
    tbody tr:nth-child(2n) {
      background: #9ec0d64d;
    }
    tbody tr:hover {
      line-height: 50px;
      background: rgba(224, 223, 223, 0.562);
    }
  }
  .no-data {
    height: 200px !important;
    font-size: 40px;
    color: #dfe8f7;
    font-weight: 600;
    margin-top: 30px;
  }
  .table-header {
    display: block;
    text-align: center;
    color: #fff;
  }
}
@media screen and (max-width: 768px) {
  .match-stats {
    .table {
      overflow-x: scroll;
      .table-box {
        width: 1260px;
      }
    }
  }
}
</style>
